<template>
  <div v-if="isShow || isOwner || isMaster">
    <ValidationProvider
      v-slot="{ errors }"
      :name="$t('agent.title')"
      :rules="required ? 'required' : ''"
    >
      <b-form-group
        :label-cols-sm="hideLabel ? null : '12'"
        :label-cols-lg="hideLabel ? null : labelCols || '3'"
        :label="
          hideLabel ? null : `${$t('agent.title')} ${required ? '*' : ''}`
        "
        label-for="agent"
      >
        <b-select
          id="agent"
          v-model="agentId"
          :state="errors[0] ? false : null"
          :disabled="readonly"
        >
          <b-form-select-option value="">
            {{ hasSelectAll ? 'เลือกทุกเอเยนต์' : 'เลือกเอเยนต์' }}
          </b-form-select-option>

          <b-form-select-option
            v-for="(agent, agentI) in agentList"
            :key="agentI"
            :value="agent.id"
            :disabled="disabled"
            >{{ agent.name }} {{ agent.isBanned ? '(ถูกระงับ)' : '' }}
          </b-form-select-option>
        </b-select>
      </b-form-group>
    </ValidationProvider>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AgentsSelectInput',
  props: {
    value: {
      type: String,
      default: '',
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    labelCols: {
      type: String,
      default: '3',
    },
    hasSelectAll: {
      type: Boolean,
      default: false,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    masterId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      agentId: '',
    }
  },
  computed: {
    ...mapGetters(['isOwner', 'isMaster', 'userInfo']),
    agentList() {
      const { masters } = this.userInfo
      if (this.masterId && masters) {
        const foundMyAgent = this.userInfo.masters.find(
          (master) => master.id === this.masterId
        )
        if(foundMyAgent) {
          const agents = JSON.parse(JSON.stringify(foundMyAgent.children))
          return agents.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
        }
        return []
      }
      const agents = JSON.parse(JSON.stringify(masters.reduce((acc, val) => acc.concat(val.children), [])))
      return agents
          .sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
    },
  },
  watch: {
    agentId(val) {
      this.$emit('update', val)
    },
    masterId() {
      this.agentId = ''
    },
    value(val) {
      if (val && !this.agentId) {
        this.agentId = val
      }
    },
  },
  created() {
    if (this.value) {
      this.agentId = this.value
    }
  },
  methods: {
    ...mapActions(['fetchAgentsByMaster']),
    fetchData() {
      // this.fetchAgentsByMaster({
      //   limit: 20,
      //   page: 1,
      //   search: '',
      //   masterId: this.masterId,
      // })
    },
  },
}
</script>
